(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6920],{

/***/ 20701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var Globe = function Globe(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 1.667A8.336 8.336 0 001.667 10c0 4.6 3.733 8.333 8.333 8.333S18.333 14.6 18.333 10 14.6 1.667 10 1.667zM3.333 10c0-.508.067-1.008.175-1.483L7.492 12.5v.833c0 .917.75 1.667 1.666 1.667v1.608C5.883 16.192 3.333 13.392 3.333 10zm9.992 3.333c.75 0 1.367.492 1.583 1.167a6.66 6.66 0 001.759-4.5 6.67 6.67 0 00-4.175-6.175v.341c0 .917-.75 1.667-1.667 1.667H9.158V7.5a.836.836 0 01-.833.833H6.658V10h5c.459 0 .834.375.834.833v2.5h.833z",
      fill: "#fff"
    })
  }));
};

var MemoGlobe = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(Globe);
/* harmony default export */ __webpack_exports__["Z"] = (MemoGlobe);

/***/ }),

/***/ 62735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ truncateString; }
/* harmony export */ });
var truncateString = function truncateString(text, maxLength) {
  if (text.length >= maxLength - 3) {
    return "".concat(text.substring(0, maxLength - 3).trim(), "...");
  }

  return text;
};

/***/ }),

/***/ 45509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ PodcastPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./pages/podcasts/podcast-episodes.module.scss
var podcast_episodes_module = __webpack_require__(12209);
var podcast_episodes_module_default = /*#__PURE__*/__webpack_require__.n(podcast_episodes_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./app/components/icons/Loader.tsx
var Loader = __webpack_require__(37387);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./services-hooks/hooks.ts + 1 modules
var hooks = __webpack_require__(90413);
// EXTERNAL MODULE: ./app/components/podcast-view/podcast-view.module.scss
var podcast_view_module = __webpack_require__(66344);
var podcast_view_module_default = /*#__PURE__*/__webpack_require__.n(podcast_view_module);
// EXTERNAL MODULE: ./app/store/slices/player.ts
var player = __webpack_require__(22564);
// EXTERNAL MODULE: ./app/store/store.ts
var store = __webpack_require__(4062);
// EXTERNAL MODULE: ./app/components/icons/Play.tsx
var Play = __webpack_require__(43935);
// EXTERNAL MODULE: ./app/components/icons/Pause.tsx
var Pause = __webpack_require__(82334);
// EXTERNAL MODULE: ./app/components/icons/HeartOutline.tsx
var HeartOutline = __webpack_require__(9761);
// EXTERNAL MODULE: ./app/hooks/favorites.hook.ts
var favorites_hook = __webpack_require__(18958);
// EXTERNAL MODULE: ./app/components/icons/HeartFull.tsx
var HeartFull = __webpack_require__(1919);
// EXTERNAL MODULE: ./app/store/slices/user.ts
var user = __webpack_require__(38886);
// EXTERNAL MODULE: ./app/context/player.context.tsx
var player_context = __webpack_require__(48346);
// EXTERNAL MODULE: ./app/context/features.context.tsx
var features_context = __webpack_require__(10833);
;// CONCATENATED MODULE: ./app/model/podcast.ts
var findChapterProgress = function findChapterProgress(chapterProgressList, permalink) {
  return chapterProgressList.find(function (chapterProgress) {
    return chapterProgress.chapter_permalink === permalink;
  });
};
// EXTERNAL MODULE: ./node_modules/react-use/esm/useIntersection.js
var useIntersection = __webpack_require__(80621);
// EXTERNAL MODULE: ./app/components/podcast-view/chapter-item.component.tsx + 4 modules
var chapter_item_component = __webpack_require__(56736);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./app/components/podcast-view/chapter-list.component.tsx








var ChapterList = function ChapterList(_ref) {
  var chapters = _ref.chapters,
      loading = _ref.loading,
      chapterProgress = _ref.chapterProgress,
      _startPlayback = _ref.startPlayback,
      downloadAvailable = _ref.downloadAvailable,
      loadNextPage = _ref.loadNextPage,
      podcast = _ref.podcast,
      showOfflineAuthGuard = _ref.showOfflineAuthGuard,
      authCallback = _ref.authCallback,
      reloadProgress = _ref.reloadProgress;
  var loadMoreTriggerRef = (0,react.useRef)(null);
  var intersection = (0,useIntersection/* default */.Z)(loadMoreTriggerRef, {
    rootMargin: "0px",
    threshold: 1
  });
  (0,react.useEffect)(function () {
    if (intersection !== null && intersection !== void 0 && intersection.isIntersecting) {
      loadNextPage();
    }
  }, [intersection]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (podcast_view_module_default()).podcast_chapter_list_wrapper,
    children: loading ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (podcast_view_module_default()).loader,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {})
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (podcast_view_module_default()).podcast_chapter_list,
      children: [chapters.map(function (chapter, chapterIndex) {
        var progress = findChapterProgress(chapterProgress, chapter.permalink);
        return /*#__PURE__*/(0,jsx_runtime.jsx)(chapter_item_component/* ChapterItem */.m, {
          podcast: podcast,
          chapter: chapter,
          progress: progress,
          reloadProgress: reloadProgress,
          index: chapterIndex,
          authCallback: authCallback,
          downloadAvailable: downloadAvailable,
          startPlayback: function startPlayback(chapter) {
            _startPlayback(chapter, chapterIndex, chapters, podcast);
          },
          showOfflineAuthGuard: showOfflineAuthGuard
        }, chapter.permalink);
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        ref: loadMoreTriggerRef
      })]
    })
  });
};
// EXTERNAL MODULE: ./app/context/offline.context.tsx
var offline_context = __webpack_require__(85889);
// EXTERNAL MODULE: ./app/utils/offline.ts + 1 modules
var offline = __webpack_require__(2358);
// EXTERNAL MODULE: ./app/components/auth/offline-auth-guard.component.tsx
var offline_auth_guard_component = __webpack_require__(11414);
// EXTERNAL MODULE: ./app/hooks/player.hook.ts
var player_hook = __webpack_require__(863);
// EXTERNAL MODULE: ./app/components/auth/auth.component.tsx + 7 modules
var auth_component = __webpack_require__(35052);
// EXTERNAL MODULE: ./app/hooks/lang.ts + 22 modules
var lang = __webpack_require__(91289);
// EXTERNAL MODULE: ./app/components/icons/AngleDown.tsx
var AngleDown = __webpack_require__(37526);
// EXTERNAL MODULE: ./app/components/icons/Globe.tsx
var Globe = __webpack_require__(20701);
;// CONCATENATED MODULE: ./app/components/podcast-view/podcast-view.component.tsx




























var PodcastTabs;

(function (PodcastTabs) {
  PodcastTabs["All"] = "All";
  PodcastTabs["Downloaded"] = "Downloaded";
  PodcastTabs["Unplayed"] = "Unplayed";
})(PodcastTabs || (PodcastTabs = {}));

var PodcastView = function PodcastView(_ref) {
  var _podcastChapters$page, _playerState$activeMe, _playerState$activeMe2, _playerState$activeMe3, _clsx;

  var podcast = _ref.podcast;

  var _usePlayerContext = (0,player_context/* usePlayerContext */.gD)(),
      isPlaying = _usePlayerContext.isPlaying,
      isMediaLoading = _usePlayerContext.isMediaLoading;

  var _useFeaturesContext = (0,features_context/* useFeaturesContext */.Pp)(),
      downloadEnabled = _useFeaturesContext.downloadEnabled,
      showRadioWebsite = _useFeaturesContext.showRadioWebsite;

  var _useOfflineContext = (0,offline_context/* useOfflineContext */.tw)(),
      offlineChapters = _useOfflineContext.offlineChapters;

  var _useAppSelector = (0,store/* useAppSelector */.CG)(user/* selectUserState */.tH),
      session = _useAppSelector.session;

  var _useState = (0,react.useState)(false),
      showOfflineAuthGuard = _useState[0],
      setShowOfflineAuthGuard = _useState[1];

  var _useGetPillowPodcastC = (0,hooks/* useGetPillowPodcastChapters */.vf)(podcast.permalink, {
    pageSize: 10
  }),
      podcastChapters = _useGetPillowPodcastC.data,
      isLoading = _useGetPillowPodcastC.isLoading,
      fetchNextPage = _useGetPillowPodcastC.fetchNextPage;

  var chapterList = (podcastChapters === null || podcastChapters === void 0 ? void 0 : (_podcastChapters$page = podcastChapters.pages) === null || _podcastChapters$page === void 0 ? void 0 : _podcastChapters$page.reduce(function (chapterList, page) {
    var _page$data$body;

    var newList = [].concat((0,toConsumableArray/* default */.Z)(chapterList), (0,toConsumableArray/* default */.Z)(((_page$data$body = page.data.body) === null || _page$data$body === void 0 ? void 0 : _page$data$body.content) || []));
    return newList;
  }, [])) || [];

  var _useGetPillowListenV = (0,hooks/* useGetPillowListenV2ProgressPodcast */.KN)(podcast.permalink, {
    enabled: false
  }),
      podcastProgressData = _useGetPillowListenV.data,
      refetchProgress = _useGetPillowListenV.refetch,
      progressLoading = _useGetPillowListenV.isLoading;

  var chaptersProgress = (podcastProgressData === null || podcastProgressData === void 0 ? void 0 : podcastProgressData.data.data) || [];
  var chapterListOffline = (0,react.useMemo)(function () {
    return chapterList.filter(function (chapter) {
      return !!(offlineChapters !== null && offlineChapters !== void 0 && offlineChapters.find(function (offlineChapter) {
        return offlineChapter.permalink === chapter.permalink;
      }));
    });
  }, [chapterList]);
  var chapterListUnplayed = (0,react.useMemo)(function () {
    return chapterList.filter(function (chapter) {
      return !(chaptersProgress !== null && chaptersProgress !== void 0 && chaptersProgress.find(function (podcastProgressItem) {
        return podcastProgressItem.chapter_permalink === chapter.permalink;
      }));
    });
  }, [chapterList, chaptersProgress]);
  (0,react.useEffect)(function () {
    if (session !== null && session !== void 0 && session.user) {
      refetchProgress();
    }
  }, [podcast, session]);

  var _useFavorites = (0,favorites_hook/* useFavorites */.r)(),
      toggleFavorite = _useFavorites.toggleFavorite,
      loading = _useFavorites.loading,
      isFavoriteCategory = _useFavorites.isFavoriteCategory;

  var _usePlayback = (0,player_hook/* usePlayback */.t)(),
      startChapterPlayback = _usePlayback.startChapterPlayback,
      stopPlayback = _usePlayback.stopPlayback;

  var playFirst = function playFirst() {
    if (chapterList.length > 0) {
      startChapterPlayback(chapterList[0], 0, chapterList, podcast);
    }
  };

  var _useState2 = (0,react.useState)(PodcastTabs.All),
      activeTab = _useState2[0],
      setActiveTab = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      showAuthGuard = _useState3[0],
      setShowAuthGuard = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      downloadAvailable = _useState4[0],
      setDownloadAvailable = _useState4[1];

  var _useState5 = (0,react.useState)(true),
      downloadCheckLoading = _useState5[0],
      setDownloadCheckLoading = _useState5[1];

  var closeAuthGuard = (0,react.useCallback)(function () {
    setShowAuthGuard(false);
  }, [setShowAuthGuard]);
  (0,react.useEffect)(function () {
    if (chapterList.length > 0) {
      if (downloadEnabled) {
        try {
          var first = chapterList[0];
          (0,offline/* checkIfCanBeDownloaded */.R)(first, function () {
            setDownloadAvailable(true);
            setDownloadCheckLoading(false);
          }, function () {
            setDownloadAvailable(false);
            setDownloadCheckLoading(false);
          });
        } catch (e) {
          setDownloadCheckLoading(false);
        }
      } else {
        setDownloadCheckLoading(false);
      }
    }
  }, [podcastChapters, downloadEnabled]);
  var playerState = (0,store/* useAppSelector */.CG)(player/* selectPlayerState */.tA);
  var isPlayingThisPodcast = ((_playerState$activeMe = playerState.activeMedia) === null || _playerState$activeMe === void 0 ? void 0 : (_playerState$activeMe2 = _playerState$activeMe.podcast) === null || _playerState$activeMe2 === void 0 ? void 0 : _playerState$activeMe2.podcast.permalink) === podcast.permalink;
  var canDownload = downloadEnabled && downloadAvailable;
  var t = (0,lang/* useTranslate */.q)();

  var _useState6 = (0,react.useState)(false),
      descriptionExpandable = _useState6[0],
      setDescriptionExpandable = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      descriptionExpanded = _useState7[0],
      setDescriptionExpanded = _useState7[1];

  var descriptionContainerRef = (0,react.useRef)(null);
  var descriptionRef = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    var _descriptionContainer, _descriptionRef$curre;

    var containerHeight = ((_descriptionContainer = descriptionContainerRef.current) === null || _descriptionContainer === void 0 ? void 0 : _descriptionContainer.clientHeight) || 0;
    var descriptionHeight = ((_descriptionRef$curre = descriptionRef.current) === null || _descriptionRef$curre === void 0 ? void 0 : _descriptionRef$curre.clientHeight) || 0;

    if (containerHeight > 0 && descriptionHeight > 0) {
      if (containerHeight < descriptionHeight) {
        setDescriptionExpandable(true);
      }
    }
  }, [podcast.description]);
  (0,react.useEffect)(function () {
    if (!(session !== null && session !== void 0 && session.user)) {
      if (activeTab === PodcastTabs.Downloaded) {
        setShowOfflineAuthGuard(true);
      }

      if (activeTab === PodcastTabs.Unplayed) {
        setShowAuthGuard(true);
      }
    }
  }, [activeTab, session, showOfflineAuthGuard]);
  var closeAuthGuardCallback = (0,react.useCallback)(function () {
    if (activeTab === PodcastTabs.Unplayed) {
      setActiveTab(PodcastTabs.All);
    }

    closeAuthGuard();
  }, [closeAuthGuard, setActiveTab]);
  var closeOfflineGuardCallback = (0,react.useCallback)(function () {
    if (activeTab === PodcastTabs.Downloaded) {
      setActiveTab(PodcastTabs.All);
    }

    setShowOfflineAuthGuard(false);
  }, [setShowOfflineAuthGuard, setActiveTab]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (podcast_view_module_default()).wrapper,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (podcast_view_module_default()).podcast_cover,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: podcast === null || podcast === void 0 ? void 0 : podcast.logo,
        alt: podcast === null || podcast === void 0 ? void 0 : podcast.name
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (podcast_view_module_default()).podcast_details,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
          children: podcast === null || podcast === void 0 ? void 0 : podcast.name
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (podcast_view_module_default()).buttons_wrapper,
          "data-navigate-row": true,
          children: [isLoading || isMediaLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: (podcast_view_module_default()).action_button,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {})
          }) : isPlaying && isPlayingThisPodcast && playerState !== null && playerState !== void 0 && (_playerState$activeMe3 = playerState.activeMedia) !== null && _playerState$activeMe3 !== void 0 && _playerState$activeMe3.podcast ? /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            disabled: isLoading,
            className: (0,clsx_m/* default */.Z)((podcast_view_module_default()).action_button, (podcast_view_module_default()).play_button),
            onClick: stopPlayback,
            "data-navigate-item": true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Pause/* default */.Z, {})
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            "data-navigate-item": true,
            disabled: isLoading,
            className: (0,clsx_m/* default */.Z)((podcast_view_module_default()).action_button, (podcast_view_module_default()).play_button),
            onClick: playFirst,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Play/* default */.Z, {})
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: (0,clsx_m/* default */.Z)((podcast_view_module_default()).action_button, (podcast_view_module_default()).favorites_button),
            onClick: function onClick() {
              return toggleFavorite(podcast);
            },
            "data-navigate-item": true,
            children: loading ? /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {}) : isFavoriteCategory(podcast) ? /*#__PURE__*/(0,jsx_runtime.jsx)(HeartFull/* default */.Z, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(HeartOutline/* default */.Z, {})
          })]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (0,clsx_m/* default */.Z)((podcast_view_module_default()).podcast_description_container, (_clsx = {}, (0,defineProperty/* default */.Z)(_clsx, (podcast_view_module_default()).expanded, descriptionExpanded), (0,defineProperty/* default */.Z)(_clsx, (podcast_view_module_default()).expandable, descriptionExpandable), _clsx)),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (podcast_view_module_default()).podcast_description,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          children: podcast === null || podcast === void 0 ? void 0 : podcast.baseline
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          ref: descriptionContainerRef,
          className: (podcast_view_module_default()).description_container,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            ref: descriptionRef,
            className: (podcast_view_module_default()).description,
            children: podcast === null || podcast === void 0 ? void 0 : podcast.description
          })
        })]
      }), descriptionExpandable && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((podcast_view_module_default()).expander, (0,defineProperty/* default */.Z)({}, (podcast_view_module_default()).open, descriptionExpanded)),
        "data-navigate-row": true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          "data-navigate-item": true,
          onClick: function onClick() {
            return setDescriptionExpanded(function (value) {
              return !value;
            });
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(AngleDown/* default */.Z, {})
        })
      })]
    }), showRadioWebsite && podcast.web && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: podcast.web,
      target: "_blank",
      rel: "noopener",
      "data-navigate-item": true,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
        className: (podcast_view_module_default()).website_button,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Globe/* default */.Z, {}), t("radio.visit-website")]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (podcast_view_module_default()).tabs_wrapper,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (podcast_view_module_default()).tabs,
        "data-navigate-row": true,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return setActiveTab(PodcastTabs.All);
          },
          className: (0,clsx_m/* default */.Z)((podcast_view_module_default()).tab, (0,defineProperty/* default */.Z)({}, (podcast_view_module_default()).active, activeTab === PodcastTabs.All)),
          "data-navigate-item": true,
          children: t("tabs.all")
        }), canDownload && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return setActiveTab(PodcastTabs.Downloaded);
          },
          className: (0,clsx_m/* default */.Z)((podcast_view_module_default()).tab, (0,defineProperty/* default */.Z)({}, (podcast_view_module_default()).active, activeTab === PodcastTabs.Downloaded)),
          "data-navigate-item": true,
          children: t("tabs.downloaded")
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return setActiveTab(PodcastTabs.Unplayed);
          },
          className: (0,clsx_m/* default */.Z)((podcast_view_module_default()).tab, (0,defineProperty/* default */.Z)({}, (podcast_view_module_default()).active, activeTab === PodcastTabs.Unplayed)),
          "data-navigate-item": true,
          children: t("tabs.unplayed")
        })]
      })
    }), activeTab === PodcastTabs.All && /*#__PURE__*/(0,jsx_runtime.jsx)(ChapterList, {
      authCallback: function authCallback() {
        return setShowAuthGuard(true);
      },
      chapters: chapterList,
      podcast: podcast,
      reloadProgress: refetchProgress,
      loading: isLoading || downloadCheckLoading,
      loadNextPage: fetchNextPage,
      chapterProgress: chaptersProgress,
      startPlayback: startChapterPlayback,
      downloadAvailable: canDownload,
      showOfflineAuthGuard: function showOfflineAuthGuard() {
        return setShowOfflineAuthGuard(true);
      }
    }), activeTab === PodcastTabs.Downloaded && /*#__PURE__*/(0,jsx_runtime.jsx)(ChapterList, {
      authCallback: function authCallback() {
        return setShowAuthGuard(true);
      },
      chapters: chapterListOffline,
      podcast: podcast,
      reloadProgress: refetchProgress,
      loading: isLoading || downloadCheckLoading,
      loadNextPage: fetchNextPage,
      chapterProgress: chaptersProgress,
      startPlayback: startChapterPlayback,
      downloadAvailable: canDownload,
      showOfflineAuthGuard: function showOfflineAuthGuard() {
        return setShowOfflineAuthGuard(true);
      }
    }), activeTab === PodcastTabs.Unplayed && /*#__PURE__*/(0,jsx_runtime.jsx)(ChapterList, {
      authCallback: function authCallback() {
        return setShowAuthGuard(true);
      },
      chapters: chapterListUnplayed,
      podcast: podcast,
      reloadProgress: refetchProgress,
      loading: isLoading || downloadCheckLoading || progressLoading,
      loadNextPage: fetchNextPage,
      chapterProgress: chaptersProgress,
      startPlayback: startChapterPlayback,
      downloadAvailable: canDownload,
      showOfflineAuthGuard: function showOfflineAuthGuard() {
        return setShowOfflineAuthGuard(true);
      }
    }), showAuthGuard && /*#__PURE__*/(0,jsx_runtime.jsx)(auth_component/* AuthGuardPopup */.J, {
      onClose: closeAuthGuardCallback,
      onSuccess: closeAuthGuard
    }), showOfflineAuthGuard && /*#__PURE__*/(0,jsx_runtime.jsx)(offline_auth_guard_component/* OfflineAuthGuardPopup */.q, {
      onClose: closeOfflineGuardCallback
    })]
  });
};
// EXTERNAL MODULE: ./app/hooks/navigation.hook.ts
var navigation_hook = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./app/components/back-button/back-button.component.tsx
var back_button_component = __webpack_require__(56227);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./app/utils/string.ts
var string = __webpack_require__(62735);
;// CONCATENATED MODULE: ./pages/podcasts/[...permalink].tsx
















var __N_SSG = true;
function PodcastPage(_ref) {
  var initialData = _ref.initialData;
  var router = (0,next_router.useRouter)(); // If the page is not yet generated, this will be displayed
  // initially until getStaticProps() finishes running

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: router.isFallback ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (podcast_episodes_module_default()).wrapper,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)("loader", (podcast_episodes_module_default()).loader),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {})
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(PodcastPageContent, {
      initialData: initialData
    })
  });
}

var PodcastPageContent = function PodcastPageContent(_ref2) {
  var _initialData$tags, _initialData$tags2;

  var initialData = _ref2.initialData;
  var router = (0,next_router.useRouter)();
  var permalink = router.query.permalink;
  var parsedPermalink = (permalink === null || permalink === void 0 ? void 0 : permalink.join("/")) || "";
  var t = (0,lang/* useTranslate */.q)();
  var goBack = (0,navigation_hook/* useNavigateBack */.ub)();
  var pageTitle = initialData.name ? "".concat(initialData.name, " - Radioline") : "Radioline";
  var pageDesc = initialData.description || "";
  var pageTags = initialData ? initialData === null || initialData === void 0 ? void 0 : (_initialData$tags = initialData.tags) === null || _initialData$tags === void 0 ? void 0 : _initialData$tags.filter(function (tag) {
    return tag.tagType !== "audioads";
  }).map(function (tag) {
    return tag.name;
  }).join(", ") : "Radioline";
  var openGraphImages = initialData !== null && initialData !== void 0 && initialData.logo ? [{
    url: initialData.logo,
    alt: pageTitle
  }] : [];
  var mainTag = (_initialData$tags2 = initialData.tags) !== null && _initialData$tags2 !== void 0 && _initialData$tags2.length ? initialData.tags[0].name : ""; // If the page is not yet generated, this will be displayed
  // initially until getStaticProps() finishes running

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: pageTags && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "keywords",
        content: pageTags
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: t("seo_title_podcast", {
        var1: initialData.name,
        var2: mainTag
      }),
      titleTemplate: "%s",
      description: "".concat(t("seo_description_podcast", {
        var1: initialData.name,
        var2: (0,string/* truncateString */.a)(pageDesc, 160)
      })).trim(),
      languageAlternates: [].concat((0,toConsumableArray/* default */.Z)((router.locales || []).filter(function (locale) {
        return locale !== "defaultLang";
      }).map(function (locale) {
        return {
          hrefLang: locale,
          href: "https://www.radioline.co/".concat(locale, "/podcasts/").concat(parsedPermalink)
        };
      })), [{
        href: "https://www.radioline.co/en/podcasts/".concat(parsedPermalink),
        hrefLang: "x-default"
      }]),
      canonical: router.locale !== "defaultLang" ? "https://www.radioline.co/".concat(router.locale, "/podcasts/").concat(parsedPermalink) : "https://www.radioline.co/en/podcasts/".concat(parsedPermalink),
      openGraph: {
        images: openGraphImages
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(back_button_component/* BackButtonBar */.K, {
      onClick: goBack
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (podcast_episodes_module_default()).wrapper,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(PodcastView, {
        podcast: initialData
      })
    })]
  });
};

/***/ }),

/***/ 6287:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podcasts/[...permalink]",
      function () {
        return __webpack_require__(45509);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 66344:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","action_button":"podcast-view_action_button___v0tG","expander":"podcast-view_expander__pWJhW","tab":"podcast-view_tab__yFa0P","wrapper":"podcast-view_wrapper__CUGOm","podcast_cover":"podcast-view_podcast_cover__rcMSG","podcast_details":"podcast-view_podcast_details__AG_Ko","buttons_wrapper":"podcast-view_buttons_wrapper__UDv4H","play_button":"podcast-view_play_button__E0dJV","favorites_button":"podcast-view_favorites_button__WDsp6","podcast_description":"podcast-view_podcast_description__DCZyI","podcast_description_container":"podcast-view_podcast_description_container__OR34G","expandable":"podcast-view_expandable__afZlk","description":"podcast-view_description__fMFwH","expanded":"podcast-view_expanded__R0hv2","description_container":"podcast-view_description_container__6WfoW","website_button":"podcast-view_website_button__ZpHN9","podcast_chapter_list_wrapper":"podcast-view_podcast_chapter_list_wrapper__Yvk6d","loader":"podcast-view_loader__jfGVE","open":"podcast-view_open__5wfhv","tabs":"podcast-view_tabs__2Znbm","tabs_wrapper":"podcast-view_tabs_wrapper__3_wfT","active":"podcast-view_active__l4f4S"};

/***/ }),

/***/ 12209:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","loader":"podcast-episodes_loader__gNprX","wrapper":"podcast-episodes_wrapper__4MYTJ","header":"podcast-episodes_header__skaRZ"};

/***/ }),

/***/ 80621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useIntersection = function (ref, options) {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), intersectionObserverEntry = _a[0], setIntersectionObserverEntry = _a[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (ref.current && typeof IntersectionObserver === 'function') {
            var handler = function (entries) {
                setIntersectionObserverEntry(entries[0]);
            };
            var observer_1 = new IntersectionObserver(handler, options);
            observer_1.observe(ref.current);
            return function () {
                setIntersectionObserverEntry(null);
                observer_1.disconnect();
            };
        }
        return function () { };
    }, [ref.current, options.threshold, options.root, options.rootMargin]);
    return intersectionObserverEntry;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIntersection);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9273,2962,7573,5052,5413,2201,9774,2888,179], function() { return __webpack_exec__(6287); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);